export default {
  title: 'Nova Segmentação',
  title_edit: 'Editando Segmentação',

  bulkEdit: 'Cadastro em massa',
  'bulkEdit.fields.checklistTypes': 'Tipos de questionário',
  'bulkEdit.fields.userGroups': 'Grupos de usuário',
  'bulkEdit.fields.placeLevels': 'Níveis de local',
  'bulkEdit.fields.assets': 'Ativos',

  'generalStep.title': 'Informações Básicas',
  'generalStep.subtitle': 'Preencha as informações da segmentação',
  'generalStep.name': 'Nome*',
  'generalStep.nameRequired': 'Favor adicionar um nome',

  'checklistTypes.title': 'Tipos de questionário',
  'checklistTypes.subtitle': 'Selecione os tipos de questionário a que esta segmentação está associada',
  'checklistTypes.selectTypeRequired': 'Selecione um tipo de questionário',

  'groupStep.title': 'Grupos de usuário',
  'groupStep.subtitle': 'Selecione os grupos de usuário que executarão esta atividade',
  'groupStep.selectGroupRequired': 'Selecione um grupo',

  'placeLevelStep.title': 'Locais/Pessoas',
  'placeLevelStep.subtitle': 'Selecione o local que será usado nessa Atividade',

  'assetStep.title': 'Ativos',
  'assetStep.subtitle': 'Selecione os ativos que serão usados nessa Atividade',
  'placeLevelStep.selectPlaceRequired': 'Selecione um local',
  'placeLevelStep.subtitle': 'Selecione os locais/pessoas que serão usados nesta atividade',

  'assetStep.title': 'Ativos',
  'assetStep.subtitle': 'Selecione os ativos que serão usados nesta atividade',
  'assetStep.validation.selectAsset': 'Selecione ao menos um ativo',
  'placeLevelStep.selectPlaceRequired': 'Selecione um local/pessoa',

  'resumeStep.title': 'Resumo',
  'resumeStep.subtitle': 'Confira os dados',

  all: 'Todos',
  ignoring: 'Ignorando'
}
